import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";

import { useLinkedAccounts } from "../useLinkedAccounts";
import { useUser } from "../useUser";
import { UserGamePreference } from "MVVM/State/user";
import { ESupportedGames } from "MVVM/@types";

export const useGamePreference = () => {
  const [gamePreference, setGamePreference] =
    useRecoilState(UserGamePreference);
  const { hasRiotLinked, hasSteamLinked, hasEpicLinked } = useLinkedAccounts();
  const { allstarUser } = useUser();
  const previousUserIdRef = useRef(allstarUser?.user?._id);

  useEffect(() => {
    const currentUserId = allstarUser?.user?._id;

    if (previousUserIdRef.current !== currentUserId) {
      previousUserIdRef.current = currentUserId;
      setGamePreference(ESupportedGames.CS2);
    }
  }, [allstarUser?.user?._id, setGamePreference]);

  useEffect(() => {
    if (gamePreference === ESupportedGames.CS2) {
      if (hasSteamLinked) return setGamePreference(ESupportedGames.CS2);
      if (hasRiotLinked) return setGamePreference(ESupportedGames.LOL);
      if (hasEpicLinked) return setGamePreference(ESupportedGames.FORTNITE);
    }
  }, [
    hasRiotLinked,
    hasSteamLinked,
    hasEpicLinked,
    gamePreference,
    setGamePreference,
  ]);

  return {
    gamePreference,
    setGamePreference,
  };
};
